import { useContext } from "react";

import { AppContexts } from "../../../providers";
import SeamMonitoringPanel from "../../seam_monitoring/MonitoringPanel";

const SmartLockMonitoringModal = () => {
  const { rental } = useContext(AppContexts.RentalsContext);

  return (
    <div
      id="smart-lock-monitoring-modal"
      className="uk-modal-full hms-modals hms-modals-small uk-modal uk-open uk-dark"
      uk-offcanvas="overlay: true; flip: true;"
    >
      <div className="uk-offcanvas-bar">
        <div className="hms-modals-main">
          <button
            className="uk-offcanvas-close uk-close-large"
            type="button"
            uk-close="true"
          ></button>
          <div className="uk-modal-header">
            <h2 className="uk-modal-title">Smart Lock Monitoring</h2>
          </div>
          <div className="uk-modal-body">
            <SeamMonitoringPanel
              rentalId={rental?.rental_id || null}
              showTitle={false}
              showFilters={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartLockMonitoringModal;